import React from 'react';

import Modal from 'js/src/components/common/ui/modal';

type Props = {
    showing: boolean;
};

const WebGlContextLostModal = React.memo(function WebGlSupportMissingModal({ showing }: Props) {
    const onClick = React.useCallback(() => {
        analytics.track('Clicked webgl context lost instruction');
    }, []);
    return (
        <Modal showing={showing} title="WebGL context lost" closeable={false}>
            <p>
                It looks like you can&apos;t edit your video right now because WebGL context is
                lost.
            </p>
            <p>
                Click&nbsp;
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="//help.lumen5.com/en/article/what-is-webgl-and-why-do-i-need-it-for-lumen5-fapsnn/"
                    onClick={onClick}
                >
                    here
                </a>{' '}
                to fix it.
            </p>
        </Modal>
    );
});

export default WebGlContextLostModal;
